if (!customElements.get('moulp-mobile-product-summary')) {
  customElements.define('moulp-mobile-product-summary', class extends HTMLElement {
    connectedCallback() {
      this.product = this.closest('product-form');
      if (!this.product || this.closest('.js-quickbuy, .quickbuy-container')) return;
      this.mobile = window.matchMedia('(max-width: 767.98px)');
      this.markers = this.markers || new Map();
      this.update = this.update || this.sync.bind(this);
      this.observer = new MutationObserver(this.update);
      this.mobile.addEventListener('change', this.update);
      this.sync();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.mobile?.removeEventListener('change', this.update);
    }

    sync() {
      this.observer.disconnect();
      const oldRow = this.product.querySelector('.moulp-rating-price-row');
      if (oldRow) {
        oldRow.querySelector('.moulp-rating-price-row__separator')?.remove();
        oldRow.before(...oldRow.childNodes);
        oldRow.remove();
      }
      this.product.querySelectorAll('[data-moulp-summary-app]').forEach((node) => {
        if (node.querySelector('.loox-rating')) {
          node.dataset.moulpSummaryBlock = node.dataset.moulpSummaryApp;
        }
      });
      const nodes = [...this.product.querySelectorAll('[data-moulp-summary-block]')]
        .sort((a, b) => Number(a.dataset.moulpSummaryOrder) - Number(b.dataset.moulpSummaryOrder));
      nodes.forEach((node, index) => {
        const key = node.dataset.moulpSummaryBlock;
        if (!this.markers.has(key)) {
          const marker = document.createElement('template');
          node.before(marker);
          this.markers.set(key, marker);
        }
        if (this.mobile.matches && this.dataset.position !== 'below') {
          if (this.children[index] !== node) this.insertBefore(node, this.children[index] || null);
        } else {
          const marker = this.markers.get(key);
          if (marker.nextSibling !== node) marker.after(node);
        }
      });
      if (this.mobile.matches) {
        const rating = nodes.find((node) => node.querySelector('.loox-rating'));
        const priceContainer = nodes.find((node) => node.classList.contains('price-container'));
        const price = priceContainer?.querySelector('.product-info__price');
        const widget = rating?.querySelector('.loox-rating');
        if (rating && price && !widget.hidden && getComputedStyle(widget).display !== 'none') {
          const row = document.createElement('div');
          row.className = 'moulp-rating-price-row';
          const separator = document.createElement('span');
          separator.className = 'moulp-rating-price-row__separator';
          separator.setAttribute('aria-hidden', 'true');
          separator.textContent = '|';
          price.before(row);
          row.append(price, separator, rating);
        }
      }
      this.observer.observe(this.product, { childList: true, subtree: true });
    }
  });
}

